// @flow

import React from 'react'
import { useTranslation } from 'react-i18next'

import { useImage } from '@bfg/effects/images'
import { useUpload } from '@bfg/effects/upload'
import { useSteps } from '@bfg/effects/steps'
import { LeftBox } from '@bfg/components/utils/LeftBox'
import { BtnListDesktop, BtnListMobile } from '@bfg/components/utils/ButtonsList'
import { DragNDrop } from '@bfg/components/utils/DragNDrop'
import { ParentEnum } from '@bfg/enums/ParentEnum'
import { Warnings } from '@bfg/components/utils/Warnings'
import { FirstPageExperiment } from '@bfg/enums/FirstPageEnum'
import {
  useFirstPageExperiment, usePageSizeExperiment
} from '@bfg/contexts/ExperimentsContext'

export const Parent = (props: any) => {
  const { t } = useTranslation()
  const parent = props.parent

  const firstPageExperiment = useFirstPageExperiment()

  const imagesHandler = useImage(parent)
  const uploadHandler = useUpload(parent, props.subscriberId)
  const stepsHandler = useSteps()
  const pageSizeExperiment = usePageSizeExperiment()

  const mobileUploadPlaceholder = parent === ParentEnum.firstParent ? t(`parent.Upload your photo`) : t(`experiments.pageShort.parent.Upload your partner's photo`)

  return (<div className="two-third">
      {/* ВОТ ТУТ РАЗКОМЕНТИТЬ */}
      {firstPageExperiment === FirstPageExperiment.Old && (<LeftBox parent={parent}/>)}

      <div className="right-box right-box__desktop">
        <Warnings/>
        {/*=============*/}
        {firstPageExperiment === FirstPageExperiment.Old && (<>
            <BtnListMobile
              parent={parent}
              subscriberId={props.subscriberId}
            />
            <DragNDrop
              handleDrop={uploadHandler.handleImageDrop}
              handleUpload={uploadHandler.handleImageUpload}
              image={imagesHandler.pic}
              uploading={uploadHandler.uploading}
              uploadPercent={uploadHandler.uploadPercent}
              mobileUploadPlaceholder={mobileUploadPlaceholder}
            />
          </>)}

        <BtnListDesktop
          handleClickNext={stepsHandler.handleClickNext}
          parent={parent}
          subscriberId={props.subscriberId}
        />
      </div>
    </div>)
}